export const COMPARISON_HIGHLIGHT_ATTRIBUTE = 'data-highlighted';
